// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var activeClass = "bg-foreground/8";

var panelBeaconId = "proc-panel-beacon";

var dotStatusClasses = [
  "toolbar-status-dot--orange-pulse",
  "toolbar-status-dot--orange",
  "toolbar-status-dot--grey"
];

function panelStateEl() {
  return Caml_option.nullable_to_opt(document.getElementById(panelBeaconId));
}

function replaceUnderscores(value) {
  return Belt_Array.joinWith(value.split("_"), "-", (function (part) {
                return part;
              }));
}

function syncFromPanelJs(buttonEl) {
  var panel = Caml_option.nullable_to_opt(document.getElementById(panelBeaconId));
  if (panel !== undefined) {
    var panel$1 = Caml_option.valFromOption(panel);
    var open_ = DomEl$GameDataCore.data(panel$1, "panel-open") === "true";
    var hasTasks = DomEl$GameDataCore.data(panel$1, "has-tasks") === "true";
    var value = panel$1.getAttribute("data-status-dot");
    var statusDot = (value == null) ? "grey" : value;
    var count = Belt_Int.fromString(DomEl$GameDataCore.data(panel$1, "processing-count"));
    var processingCount = count !== undefined ? count : 0;
    DomEl$GameDataCore.toggleClassForce(buttonEl, activeClass, open_);
    buttonEl.setAttribute("aria-expanded", open_ ? "true" : "false");
    var ariaLabel = processingCount > 0 ? "Notifications — " + String(processingCount) + " in progress" : "Notifications";
    buttonEl.setAttribute("aria-label", ariaLabel);
    var dotWrap = buttonEl.querySelector("[data-notifications-dot-wrap]");
    if (!(dotWrap == null)) {
      DomEl$GameDataCore.toggleClassForce(dotWrap, "hidden", !hasTasks);
    }
    var dot = buttonEl.querySelector("[data-notifications-dot]");
    if (!(dot == null)) {
      Belt_Array.forEach(dotStatusClasses, (function (name) {
              DomEl$GameDataCore.removeClass(dot, name);
            }));
      if (hasTasks) {
        return DomEl$GameDataCore.addClass(dot, "toolbar-status-dot--" + replaceUnderscores(statusDot));
      } else {
        return DomEl$GameDataCore.addClass(dot, "toolbar-status-dot--grey");
      }
    } else {
      return ;
    }
  }
  var dotWrap$1 = buttonEl.querySelector("[data-notifications-dot-wrap]");
  if (!(dotWrap$1 == null)) {
    DomEl$GameDataCore.addClass(dotWrap$1, "hidden");
  }
  DomEl$GameDataCore.removeClass(buttonEl, activeClass);
  buttonEl.setAttribute("aria-expanded", "false");
}

function attachPanelObserver(self) {
  var match = Caml_option.nullable_to_opt(document.getElementById(panelBeaconId));
  var match$1 = self.observer;
  if (match === undefined) {
    return ;
  }
  if (match$1 !== undefined) {
    return ;
  }
  var observer = new MutationObserver((function () {
          syncFromPanelJs(self.el);
        }));
  observer.observe(Caml_option.valFromOption(match), {
        attributes: true,
        attributeFilter: [
          "data-panel-open",
          "data-has-tasks",
          "data-status-dot",
          "data-processing-count"
        ]
      });
  self.observer = Caml_option.some(observer);
}

function mounted() {
  var self = this ;
  self.observer = undefined;
  syncFromPanelJs(self.el);
  attachPanelObserver(self);
}

function updated() {
  var self = this ;
  syncFromPanelJs(self.el);
  attachPanelObserver(self);
}

function destroyed() {
  var self = this ;
  var observer = self.observer;
  if (observer !== undefined) {
    Caml_option.valFromOption(observer).disconnect();
  }
  self.observer = undefined;
}

var notificationsNavSync = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  activeClass ,
  panelBeaconId ,
  dotStatusClasses ,
  panelStateEl ,
  replaceUnderscores ,
  syncFromPanelJs ,
  attachPanelObserver ,
  mounted ,
  updated ,
  destroyed ,
  notificationsNavSync ,
}
/* mounted Not a pure module */
